import React from "react";
import '../assets/styles/Project.scss';

// Automatically import all images from assets/images directory
const images: { [key: string]: string } = {};
function importAll(r: any) {
  r.keys().forEach((item: string) => {
    images[item.replace('./', '')] = r(item);
  });
}
importAll((require as any).context('../assets/images', false, /\.(png|jpe?g|svg|gif)$/i));

// Helper function to resolve image by filename with fallback
const getImage = (name: string): string => {
  return images[name] || images['bot.png'] || '';
};

const projectsData = [
  {
    category: "Projects",
    items: [
      {
        img: getImage('rover.jpg'),
        title: "GNSS RTK-enabled Ground Rover",
        description:
          "Deployed a GNSS RTK-enabled ground rover for high-precision autonomous navigation in vineyards at NRCG, collaborating with scientists for agricultural data collection.",
        link: "https://yourlinkforgnssrover.com",
        linkEnabled: false,
      },
      {
        img: getImage('drone.jpg'),
        title: "Drone for Pipeline Leakage Detection",
        description:
          "Designed and built a drone in collaboration with CoEOGE for data collection and pipeline leakage detection using aerial monitoring techniques.",
        link: "https://yourlinkfordroneproject.com",
        linkEnabled: false,
      },
    ],
  },
  {
    category: "Personal Projects",
    items: [
      {
        img: getImage('Mecanum.gif'),
        title: "Mecanum Robot Kinematics Odometry and Hardware Interface",
        description:
          "Developed a complete MATLAB implementation for simulating forward kinematics (odometry), inverse kinematics, and real-time teleoperation of an omnidirectional 4-wheel Mecanum robot. Includes a fully functional Arduino interface to transmit calculated wheel velocities directly to physical hardware.",
        link: "https://yourlinkforgnssrover.com",
        linkEnabled: false,
      },
      {
        img: getImage('RealSense.jpeg'),
        title: "Intel RealSense ROS2 Live Web Streaming, Image Capture & RViz2 Telemetry",
        description:
          "Interfaced Intel RealSense depth camera with ROS2 and built a custom web application for real-time live video telemetry. Features interactive remote image capture stored on local disk, live preview rendering, and full 3D spatial telemetry visualization in RViz2.",
        link: "https://yourlinkfordroneproject.com",
        linkEnabled: false,
      },
      {
        img: getImage('RTK+IMU.jpeg'),
        title: "Adaptive Kalman Filter Sensor Fusion for GNSS-RTK & IMU Positioning",
        description:
          "Developed an Adaptive Kalman Filter (AKF) sensor fusion framework to integrate high-precision RTK position data with IMU yaw orientation feedback. Conducted extensive field testing across diverse environmental and atmospheric conditions, achieving exceptional positioning accuracy, drift mitigation, and robust state estimation.",
        link: "https://yourlinkforgnssrover.com",
        linkEnabled: false,
      },
      {
        img: getImage('czflies.jpg'),
        title: "Crazyflie Quadrotors Multi-Drone Flight Control & Qualisys Tracking",
        description:
          "Designed, tested, and validated Crazyflie quadrotors using Qualisys for state feedback, implementing custom control and tracking algorithms for experimental flight evaluation. Executed solo flight tests with custom control code and performed simultaneous multi-drone flight by spawning 2 Crazyflie quadrotors concurrently.",
        link: "https://yourlinkfordroneproject.com",
        linkEnabled: false,
      },
      {
        img: getImage('Turtlebot.jpeg'),
        title: "iRobot Create 3 High-Precision Lawnmower Navigation with Qualisys, MATLAB & ROS2",
        description:
          "Developed high-precision autonomous navigation and lawnmower coverage path planning for iRobot Create 3 integrating Qualisys motion capture, MATLAB, and ROS2. Implemented a custom motion controller achieving an exceptional 0.01 tracking accuracy.",
        link: "https://yourlinkforturtlebot3.com",
        linkEnabled: false,
      },
      {
        img: getImage('ROS2_joy.png'),
        title: "ROS2 Digital Twin Manipulator",
        description:
          "A complete ROS 2 framework for controlling a robotic manipulator with Arduino hardware integration, featuring FK/IK control modes and MoveIt planning capabilities. Integrates joystick and GUI FK control, RViz visualization, seamless control mode switching, and real-time hardware feedback.",
        link: "https://yourlinkforgnssrover.com",
        linkEnabled: false,
      },
      {
        img: getImage('ROS2+Arduino.png'),
        title: "ROS2–Arduino Robotics Control and Hardware Integration",
        description:
          "Developed a ROS2-based robotics control framework integrating Arduino hardware for bidirectional communication, sensor data acquisition, and real-time control of motors, servos, and other actuators using C++ and Python.",
        link: "https://yourlinkforgnssrover.com",
        linkEnabled: false,
      },
      {
        img: getImage('Sweve1.png'),
        title: "Swerve Drive Robot using ROS2",
        description:
          "Developed a ROS2-based swerve drive robotic platform capable of independent wheel steering and motion control, enabling precise omnidirectional movement and autonomous navigation.",
        link: "https://yourlinkforgnssrover.com",
        linkEnabled: false,
      },
      {
        img: getImage('Tb3.png'),
        title: "Deep Reinforcement Learning Navigation on TurtleBot3 Using TD3 with Comparative Reward Design",
        description:
          "Developed an autonomous navigation system for TurtleBot3 using the TD3 reinforcement learning algorithm, evaluating different reward functions to improve obstacle avoidance, path efficiency, and navigation performance.",
        link: "https://yourlinkforgnssrover.com",
        linkEnabled: false,
      },
      {
        img: getImage('IK_Transition.gif'),
        title: "Advanced Robotic Manipulator Kinematics Dynamics and Hardware Interface",
        description:
          "Designed and analyzed a robotic manipulator by studying its kinematic and dynamic behavior, while developing the hardware interface for accurate motion control and real-time operation.",
        link: "https://yourlinkforgnssrover.com",
        linkEnabled: false,
      },
      {
        img: getImage('mir.jpg'),
        title: "Miniature Inspection Robot (MIR)",
        description:
          "The MIR remote inspection vehicle enables precise, real-time inspections in confined industrial spaces using a flexible design with advanced LiDAR and camera systems. (ROS, Python, 3D Printing, GNSS RTK, Fusion 360).",
        link: "https://yourlinkformir.com",
        linkEnabled: false,
      },
      {
        img: getImage('bot.png'),
        title: "Navigation on TurtleBot 3 with Gazebo and RViz",
        description:
          "Implemented navigation on the ROS platform using TurtleBot 3, performing obstacle avoidance and optimized path planning to reach goal positions. Utilized SLAM with LiDAR for mapping and visualized the 3D environment in RViz. (ROS, Rviz, SLAM, D*, Gazebo).",
        link: "https://yourlinkforturtlebot3.com",
        linkEnabled: false,
      },
      {
        img: getImage('arm.png'),
        title: "Bionic ARM",
        description:
          "The bionic arm project developed a functional prosthetic that responds to user commands, showcasing the potential of advanced prosthetics to enhance the lives of individuals with limb loss or impairment. (3D Printing, Arduino, Sensors, Robotics).",
        link: "https://yourlinkforbionicarm.com",
        linkEnabled: false,
      },
      {
        img: getImage('pa.png'),
        title: "Personal Assistant Robot",
        description:
          "The PA robot is a telecontrolled mobile platform capable of various movements and operations, operated through a custom-built application. (3D Printing, Arduino, Sensors, Robotics).",
        link: "https://yourlinkforpersonalassistantrobot.com",
        linkEnabled: false,
      },
      {
        img: getImage('traffic.png'),
        title: "Intelligent Traffic Control System With Smart Box",
        description:
          "A project to automate traffic signals using a self-made smart box that monitors and regulates traffic autonomously, with manual override for emergencies and real-time feedback displayed on an LCD for central monitoring. (Arduino, Sensors, PCB Design, Communication Protocols).",
        link: "https://yourlinkforintelligenttrafficcontrol.com",
        linkEnabled: false,
      },
      {
        img: getImage('Algo.png'),
        title: "Advanced Path Planning with RRT & PRM",
        description:
          "Developed intelligent path planning in MATLAB using RRT and PRM algorithms. Fine-tuned cost maps for efficient route optimization, simulating real-time robotic navigation in complex environments. (MATLAB, Robotics Toolbox, Optimization).",
        link: "https://yourlinkforintelligenttrafficcontrol.com",
        linkEnabled: false,
      },
      {
        img: getImage('check.png'),
        title: "Production Monitoring with ThingSpeak",
        description:
          "Developed a centralized HTML-based interface to visualize real-time widgets and production flow graphs from ThingSpeak, streamlining multi-line monitoring at Salzer Groups. (ThingSpeak, HTML, IoT, Data Visualization).",
        link: "https://yourlinkforintelligenttrafficcontrol.com",
        linkEnabled: false,
      },
      {
        img: getImage('entry.png'),
        title: "IIoT-Based Entry Monitor & Alarm System",
        description:
          "Developed an IIoT-based Entry Monitoring & Alarm System to enhance facility security through real-time sensor data, alerts, and automated control.",
        link: "https://yourlinkforintelligenttrafficcontrol.com",
        linkEnabled: false,
      },
      {
        img: getImage('things.png'),
        title: "IIoT-Based Production Monitor Development",
        description:
          "Developed an IIoT-based Production Monitor to enhance operational efficiency through real-time data tracking and analysis.",
        link: "https://yourlinkforintelligenttrafficcontrol.com",
        linkEnabled: false,
      },
      {
        img: getImage('ros.png'),
        title: "ROS Workspace Mapping and Scanning",
        description:
          "Mapped and scanned workspace boundaries in ROS to teach the bot about obstacles and its path.",
        link: "https://yourlinkforintelligenttrafficcontrol.com",
        linkEnabled: false,
      },
    ],
  },
];

function Project() {
  return (
    <div className="projects-container" id="projects">
      {projectsData.map(({ category, items }) => (
        <React.Fragment key={category}>
          <h1>{category}</h1>
          <div className="projects-grid">
            {items.map(({ img, title, description, link, linkEnabled }, index) =>
              linkEnabled ? (
                <a
                  key={index}
                  href={link}
                  target="_blank"
                  rel="noreferrer"
                  className="project"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <div className="project-image-container">
                    <img src={img} className="zoom project-image" alt={title} />
                  </div>
                  <h2>{title}</h2>
                  <p>{description}</p>
                </a>
              ) : (
                <div key={index} className="project">
                  <div className="project-image-container">
                    <img src={img} className="zoom project-image" alt={title} />
                  </div>
                  <h2>{title}</h2>
                  <p>{description}</p>
                </div>
              )
            )}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}

export default Project;
